import React from "react";
import CTAButton from "../../generalComponents/ctaButton";
import {PartnersImage} from "../../../assets/assets";


export default function HeaderComponent() {


    return (
        <div>
            {/* Header Image */}
            <div className="mb-20">
                <img
                    className="object-cover w-full"
                    style={{
                        height: "700px",
                    }}
                    // src="https://cdn.shopify.com/s/files/1/0070/7032/articles/Banner_-_1848_x_784_-_Option_D.png?v=1729263104&originalWidth=1848&originalHeight=782&width=1800"
                    // src="https://cdn.shopify.com/s/files/1/0070/7032/articles/Image1_2048x2048_7ebeafc0-21df-4d6f-b1f6-c205149ba3c7.png?v=1729517839&originalWidth=1848&originalHeight=782&width=1800"
                    src={PartnersImage}
                    // src={"https://cdn.shopify.com/s/files/1/0070/7032/articles/shopify_20stores_c5b4fe86-c42b-4b42-9c71-79e1ee9abd02.png?v=1740766930&originalWidth=1848&originalHeight=782&width=1800"}
                    alt="Header Banner"
                />
                <style>
                    {`
          @media (max-width: 767px) {
            img[alt="Header Banner"] {
              height: 400px !important;
            }
          }
        `}
                </style>
            </div>

            <div className="flex items-center justify-center">
                <div className="text-center text-black space-y-16" id="header-text-block">
                    <h1
                        className="text-[80px]"
                        id="header-title"
                        style={{
                            fontWeight: "600",
                            fontSize: "80px",
                            lineHeight: "1.2",
                        }}
                    >
                        <div>The cashback you love.</div>
                        <div>From Pabloo.</div>
                    </h1>

                    <p
                        className="font-semibold text-3xl px-80"
                        id="header-subtext"
                        style={{
                            lineHeight: "1.2",
                        }}
                    >
                        Earn rewards effortlessly on every purchase, with instant payouts at top retailers.
                        Backed by 256-bit encryption and fraud protection, so earnings and data are secure.

                        <div className="flex items-center justify-center mt-8">
                            <CTAButton text="&nbsp;&nbsp;Start for free"/>
                        </div>
                    </p>
                </div>

                <style>
                    {`
        @media (max-width: 767px) {
            #header-title {
                font-size: 32px !important;
                line-height: 1.2 !important;
            }

            #header-subtext {
                font-size: 16px !important;
                padding-left: 2.5rem !important;
                padding-right: 2.5rem !important;
            }

            #header-text-block > * + * {
                margin-top: 1.5rem !important;
            }
        }
        `}
                </style>
            </div>


        </div>
    );
}
